
import React, {useEffect, useState} from 'react';

import LoftyCarousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';

import {connect} from 'react-redux';
import html2pdf from 'html2pdf.js';
import LoftyDropdownComponent from '../../components/loftydropdowncomponent';
import LoftyCountDown from '../../components/loftycountdown';
import LoftyCartCarousel from '../../components/loftycartcarousel';
import LoftyThreeCarousel from '../../components/loftythreecarousel';
import LoftyCarouselPlugin from '../../components/LoftyCarouselPlugin';
import LoftyLeaftMap from '../../components/loftyLeaftMaps';
import LoftyAnimatedParticleBackground from '../../components/loftyAnimatedParticleBackground';
import LoftyGoogleLoginComponent from '../../components/loftyGoogleLoginComponent';

import { addLoftyToken, deleteLoftytoken } from '../../actions/auth.actions';

import {getAllclientestcsz7 } from '../../api/clientestcsz7.api'

import './landing1xyi8.scss';


// Hamburger
function loftyInitHam() {
  try {
  // eslint-disable-next-line no-restricted-globals
    window.addEventListener('click', (event) => {
      let originPointLeft = '';
      const comp = event.target.className;
      if (comp.includes('menu__btn') || comp.includes('span_middle') || comp.includes('span_before') || comp.includes('span_after')) {
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        spanData.forEach((item) => {
          originPointLeft = item.style.left;
        });
        res.forEach((item) => {
          item.style.left = '0px';
        });
        spanData.forEach((item) => {
          item.style.left = '-300px';
        });
        closeBtn.forEach((item) => {
          item.style.left = '10px';
        });
      } else {
        if (comp === 'menu__box') {
          return;
        }
        if (comp === 'linkshref') {
          return;
        }
        if (comp === 'menu__item') {
          return;
        }
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        res.forEach((item) => {
          item.style.left = '-300px';
        });
        spanData.forEach((item) => {
          item.style.left = originPointLeft;
        });
        closeBtn.forEach((item) => {
          item.style.left = '-100%';
        });
      }
    });
  } catch (error) {
    // console.log(error);
  }
}    
    




const Planding1xyi8 = ({
  match,
  history,
  loftytoken,
  loftyuser,
  addLoftyUserApp,
  deleteLoftytokenApp,
  addLoftyTokenApp,
  
}) => {

	const [loftyendpoint_670844473b1b93d52424ae52, setLoftyEndpoint_670844473b1b93d52424ae52] = useState([]);
	
useEffect(() => {
		const loftyHandleData = async () => {
			const loftyres_670844473b1b93d52424ae52 = await getAllclientestcsz7({ token: loftytoken || 'asdsa' });
			setLoftyEndpoint_670844473b1b93d52424ae52(loftyres_670844473b1b93d52424ae52.data);
		}
		loftyHandleData();
	}, []);



  
  setTimeout(() => { loftyInitHam(); }, 2000);

  
  

  
  return (
    <div id="id668be0d0914da0d427fe93f3" >

      <div id="iw4j" className="">
      
      <div id="ips2" className="">
      
      <div id="itmdc" className="">
      
      <img
        className=""
        id="ismeq"
        src="https://assetsprojects.s3.amazonaws.com/404m4lim23uvzm3.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="iacot" className="">
      
        <LoftyDropdownComponent
          id="iejkse"
          className="gjs-dropdown-menu-container link-navbar "
          childrenShow={
            <>
              <div id="icmp9k" className="gjs-dropdown-menu-trigger ">
<>Servicios</></div>

            </>
          }
          childrenHover={
            <>
              <div id="ifwrr4" className="gjs-dropdown-menu-content " style={{display: 'block'}}>

      <a
        target=""
        className="link-navbar "
        id="ixxmu"
        href="/tret"
        type="button"
      >
        
    <div id="ikc1x" className="">
    <>TRET</>
    </div>
    
      </a>
      
      <a
        target=""
        className="link-navbar "
        id="i2hsg"
        href="/"
        type="button"
      >
        
    <div id="ij3vk" className="">
    <>CFO Externo</>
    </div>
    
      </a>
      </div>

            </>
          }
        />
        
      <a
        target=""
        className="link-navbar "
        id="ibmm3s"
        href="/sobrenosotros"
        type="button"
      >
        
    <div id="iol6vk" className="">
    <>Sobre Nosotros</>
    </div>
    
      </a>
      
      </div>
      
      <img
        className=""
        id="iok6z3"
        src="https://assetsprojects.s3.amazonaws.com/405opfilkvb1chy.jpg"
        alt="undefined"
      />
      
      <div id="icq3pj" className="">
      
      <div id="" className="contentwrapperanimated ">
      
      <div id="" className="container_animated ">
      
      <label id="" className="menu__btn ">
      
      <span className="span_before " id="">
        
      </span>
      
      <span className="span_middle " id="">
        
      </span>
      
      <span className="span_after " id="">
        
      </span>
      
      </label>
      
      <label id="" className="menu__close__btn ">
      
      <span className="span__close__left " id="">
        
      </span>
      
      <span className="span__close__right " id="">
        
      </span>
      
      </label>
      
      <ul id="" className="menu__box ">
        
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/tret"
        type=""
      >
        <>TRET</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/sobrenosotros"
        type=""
      >
        <>Sobre Nosotros</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      </li>
      
      <li className="linkshref " id="">
        
      </li>
      
      <li className="linkshref " id="">
        
      </li>
      
      </ul>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="ihk8" className="">
      
      <div id="it6xg" className="">
      
      <div className="" id="ir8ccl">
        <>Financieros enfocados en crear valor en Startups y Pymes  </>
      </div>
      
      <div className="" id="ip3sl">
        <>Externaliza tu CFO con TRET</>
      </div>
      
        <a
          target=""
          className="botonprimary "
          id="iygz58"
          href="#"
        >
          
    <div id="i9ywzc" className="">
    <>Contáctanos</>
    </div>
    
        </a>
        
      </div>
      
      <div id="if5pi" className="">
      
      <div className="" id="i803s">
        <>Descubre cómo podemos ayudarte a maximizar el valor de tu empresa, personalizando soluciones financieras para el momento actual de tu negocio</>
      </div>
      
      <div id="if2hqk" className="">
      
      <img
        className=""
        id="iwhka9"
        src="https://assetsprojects.s3.amazonaws.com/eewk5ilyd7tcam.jpg"
        alt="undefined"
      />
      
      </div>
      
      </div>
      
      </div>
      
      <div id="i6xx" className="">
      
      <div id="i0tfl" className="">
      
      <div id="ivvvb5" className="">
      
      <div id="iyqmu8" className="">
      
      <div className="" id="ia652r">
        <>Nuestra experiencia en diferentes sectores nos permite tener una visión practica y estratégica de tu empresa</>
      </div>
      
      </div>
      
      </div>
      
      <div id="im4sk2" className="">
      
      <div id="ir78x3" className="">
      
      <div className="" id="ivwm6e">
        <>20%</>
      </div>
      
      <div className="" id="ioggqi">
        <>Del costo que significa tener un gerente financiero de planta</>
      </div>
      
      </div>
      
      <div id="ijr9pj" className="">
      
      <div className="" id="ib9eki">
        <>+8 horas semanales</>
      </div>
      
      <div className="" id="i7m5pn">
        <>Liberarás tiempo valioso, que podrás enfocar en el core de tu empresa  </>
      </div>
      
      </div>
      
      </div>
      
      <div id="it9es4" className="">
      
      <div id="irbv49" className="">
      
      <div className="servicios " id="ihtsq2">
        <>Servicio de CFO</>
      </div>
      
      <div className="servicios " id="iy8ixg">
        <>Eficiencia y ahorro</>
      </div>
      
      <div id="iy6kjn" className="">
      
      </div>
      
      <div className="servicios " id="iy1p8n">
        <>Expertos en finanzas</>
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="i3dh" className="">
      
      <div className="" id="i93l3">
        <>Nos hemos convertido en un aliado para las empresas </>
      <b className="" id="">
        <>sin importar su industria</>
      </b>
      
      </div>
      
      <div id="in7yz3" className="">
      
      <div
        id="ina81l"
        className=""
        data-aos="fade-up"
        data-aos-duration="2000"
      >
      
        <div id="ixj2u7" className="">
          
            <div>
              <LoftyCarousel
                responsive={{
                  superLargeDesktop: {
                    breakpoint: {max: 4000, min: 3000},
                    items: 5,
                  },
                  desktop: {
                    breakpoint: {max: 3000, min: 1024},
                    items: 3,
                  },
                  tablet: {
                    breakpoint: {max: 1024, min: 464},
                    items: 3,
                  },
                  mobile: {
                    breakpoint: {max: 464, min: 0},
                    items: 1,
                  },
                }}
                infinite
                autoPlay
              >
                {
                  loftyendpoint_670844473b1b93d52424ae52.map((loftyitem) => (
                    <div key={loftyitem._id} className="" id="iauerl">
                      
      <div id="iahxb3" className="">
      
        <img
          className=""
          id="iuc0og"
          alt=""
          src={loftyitem.loftyUrl}
        />
        
      </div>
      
                    </div>
                  ))
                }
              </LoftyCarousel>
            </div>
            
        </div>
        
      </div>
      
      </div>
      
      </div>
      
      <div id="i7qj2" className="">
      
      <div id="innv15" className="">
      
      <div id="i987ev" className="">
      
      <div className="seccion-info " id="i7m4ws">
        
      <br className="" id="" />
      
      </div>
      
      <div className="titulo-seccion " id="ilumsw">
        <>Finanzas Estratégicas</>
      </div>
      
      </div>
      
      <div id="ibpnu5" className="">
      
      <div className="descripcion-seccion " id="i9ttxg">
        <>Diseñamos el kit financiero que genera más valor a tu empresa. </>
      </div>
      
      </div>
      
      </div>
      
      <div id="i7siqb" className="">
      
      <div
        id="i83x0r"
        className=""
        data-aos="fade-up"
        data-aos-duration="undefined"
      >
      
      <div id="i33brf" className="tarjeta-1 ">
      
      <div id="i9dbzo" className="">
      
      <div id="iwl4dh" className="tarjeta-contenido-superior ">
      
      <div id="iew0z4" className="">
      
      <div id="ikllzd" className="">
      
      <img
        className=""
        id="i0r9n1"
        src="https://assetsprojects.s3.amazonaws.com/eewk5ilyop8x0z.png"
        alt="undefined"
      />
      
      </div>
      
      </div>
      
      <div id="io0uqc" className="">
      
      <div className="" id="i9nin1">
        <>Eficacia</>
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="i1h1ui" className="">
      
      <div className="" id="ifkloh">
        <>Alineamos la contabilidad, el presupuesto y  el flujo de caja de tu empresa para poder brindarte </>
      <span className="gjs-hovered " id="ilfmdu-2">
        <>una visión practica del estado actual del negocio y poder analizar ahorros de costos y/o nuevas inversiones</>
      </span>
      
      <br className="" id="" />
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div
        id="in782c"
        className=""
        data-aos="fade-up"
        data-aos-duration="undefined"
      >
      
      <div id="itcwij" className="tarjeta-1 ">
      
      <div id="i7jdco" className="">
      
      <div id="ir7g1t" className="tarjeta-contenido-superior ">
      
      <div id="ietht8" className="">
      
      <div id="iawlst" className="">
      
      <img
        className=""
        id="imtqfh"
        src="https://assetsprojects.s3.amazonaws.com/eewk5ilyopgwus.png"
        alt="undefined"
      />
      
      </div>
      
      </div>
      
      <div id="ilytiy" className="">
      
      <div className="" id="i0r8o4">
        <>Eficiencia</>
      <br className="" id="" />
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="ieai39" className="">
      
      <div className="" id="inl5ao">
        <>Confiar en profesionales para el análisis financiero y la proyección de tu empresa te permitirá generar más valor a la empresa, ahorrando tiempo y dinero valioso</>
      <br className="" id="" />
      
      <br className="" id="" />
      
      <br className="" id="" />
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div
        id="ixax6f"
        className=""
        data-aos="fade-up"
        data-aos-duration="undefined"
      >
      
      <div id="i3ng7p" className="tarjeta-1 ">
      
      <div id="idyhxi" className="">
      
      <div id="inooqa" className="tarjeta-contenido-superior ">
      
      <div id="itekaj" className="">
      
      <div id="iwocwh" className="">
      
      <img
        className=""
        id="ir6woq"
        src="https://assetsprojects.s3.amazonaws.com/eewk5ilyopibyi.png"
        alt="undefined"
      />
      
      </div>
      
      </div>
      
      <div id="ihr8qa" className="">
      
      <div className="" id="i00og4">
        <>Confianza</>
      <br className="" id="" />
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="ice414" className="">
      
      <div className="" id="i7335b">
        <>Nuestro servicio de gerente financiero te permite externalizar uno de los roles más cruciales de tu empresa, </>
      <br className="" id="" />
      
      <br className="" id="" />
      <>Trabaja con expertos en finanzas empresariales que te ayudarán a navegar en los desafíos actuales empresariales y económicos.</>
      <br className="" id="" />
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="isbhos" className="">
      
      <div
        id="iq3f0x"
        className=""
        data-aos="fade-up"
        data-aos-duration="undefined"
      >
      
      <div id="i3caqq" className="">
      
      <div id="irc04x" className="">
      
      <div id="i43gtg" className="">
      
      <div id="i39utq" className="">
      
      <div className="subtitulo " id="i6p8b1">
        <>Optimización De Costos</>
      </div>
      
      <div className="descripcion2 " id="i1mwly">
        <>Tener un gerente financiero de planta puede ser muy costoso. y la realidad es que muchas empresas no necesitan un financiero full-time </>
      <br className="" id="" />
      
      </div>
      
      </div>
      
      <div id="ibf9kj" className="">
      
      <div className="contenido-significativo " id="i1zxie">
        <>15% - 20%</>
      </div>
      
      </div>
      
      </div>
      
      <div id="i57dji" className="">
      
      <div id="itrilx" className="">
      
      <div className="contenido-significativo " id="id6wph">
        <>+10 años</>
      </div>
      
      </div>
      
      <div id="i2hmye" className="">
      
      <div className="subtitulo " id="i1mwnf">
        <>Nuestra Experiencia</>
      </div>
      
      <div className="descripcion2 " id="ivi9ki">
        <>Nuestra experiencia en diferentes sectores nos permite darle una visión practica y estratégica  de su negocio teniendo en cuenta el tamaño, su actual momento financiero, sus fortalezas y puntos de mejora.  </>
      <br className="" id="" />
      
      </div>
      
      </div>
      
      </div>
      
      <div id="ic07ai" className="">
      
      <div id="ildooc" className="">
      
      <div className="subtitulo " id="ijgi5b">
        <>Tenernos de Aliados</>
      </div>
      
      <div className="descripcion2 " id="ip083n">
        <>Tener a la mano un aliado con la experiencia para ayudar a las diferentes áreas involucradas en el proceso financiero ayudará a la gerencia a liberar al menos  8 horas semanales</>
      <br className="" id="" />
      
      </div>
      
      </div>
      
      <div id="ieu90w" className="">
      
      <div className="contenido-significativo " id="iz2wph">
        <>8 horas</>
      </div>
      
      </div>
      
      </div>
      
      <p className="" id="iyyhre">
        
      </p>
      
      </div>
      
      <div id="ijmh6k" className="">
      
      <div className="seccion-info " id="i6044t">
        <>Nuestros Beneficios</>
      </div>
      
      <div className="titulo-seccion " id="iph2u6">
        <>Que Hacemos BIEN</>
      </div>
      
      <div className="" id="icukx8">
        
    <div id="" className="page ">
    
    <div id="" className="section ">
    
    <div id="" className="layoutArea ">
    
    <div id="" className="column ">
    
    <div id="ijcwp1" className="">
    
    <div id="i7mwle" className="">
    
      <p className="" id="">
        
      <span className="" id="ixh1ge">
        <>Elaboramos y hacemos seguimiento al presupuesto<br /></>
      </span>
      
      </p>
      
    </div>
    
    <div id="injgbi" className="">
    
      <p className="" id="ijg4lf">
        
      <span className="" id="iatspf">
        <>Análisis de flujo de caja y optimización de la rentabilidad<br /></>
      </span>
      
      </p>
      
    </div>
    
    <div id="ic8kyi" className="">
    
      <p className="" id="iwm9u3">
        
      <span className="" id="ib1ul3">
        <>Establecemos indicadores de gestión financiera y alertas tempranas<br /></>
      </span>
      
      </p>
      
    </div>
    
    <div id="iaxxnp" className="">
    
      <p className="" id="i6a6bb">
        
      <span className="" id="iz8pbu">
        <>Análisis y modelación de escenarios futuros para la empresa<br /></>
      </span>
      
      </p>
      
    </div>
    
    <div id="ij9of5" className="">
    
      <p className="" id="iowcvd">
        
      <span className="" id="i5wdvw">
        <>Asesoría en la mitigación de riesgos financieros y como cubrirse frente a<br />los riesgos que está más expuesto la empresa<br /></>
      </span>
      
      </p>
      
    </div>
    
    <div id="iqha5i" className="">
    
      <p className="" id="i3difk">
        
      <span className="" id="i0w0rl">
        <>Acompañamiento en la evaluación financiera de nuevos proyectos<br /></>
      </span>
      
      </p>
      
    </div>
    
    <div id="i7mmzg" className="">
    
      <p className="" id="in9k4u">
        
      <span className="" id="iwdtiz">
        <>Análisis de los productos financieros pertinentes (costo-beneficio) para </>
      </span>
      
      <span className="" id="imxdb2">
        <>un mayor beneficio de la empresa</>
      </span>
      
      </p>
      
    </div>
    
    <div id="itdtj1" className="">
    
      <p className="" id="ihtj4i">
        
      <span className="" id="i79rvb">
        <>Análisis de márgenes de venta de la empresa y del sector, y optimizamos<br />bajo las mejores practicas<br /></>
      </span>
      
      </p>
      
    </div>
    
    <div id="ikay7d" className="">
    
      <p className="" id="i1qj5y">
        
      <span className="" id="ig966t">
        <>Análisis y control de costos<br /></>
      </span>
      
      </p>
      
    </div>
    
    </div>
    
    </div>
    
    </div>
    
    </div>
    
    </div>
    
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="irqujg" className="">
      
      <div id="iq210w" className="">
      
      <div className="seccion-info centro " id="i3vh0s">
        <>Información</>
      <br className="" id="" />
      
      </div>
      
      <div className="titulo-seccion centro " id="icw6p6">
        <>El Nuevo Rol Del Gerente Financiero</>
      </div>
      
      </div>
      
      <div id="iwqp1k" className="">
      
      <div
        id="i5mci2"
        className=""
        data-aos="fade-up"
        data-aos-duration="undefined"
      >
      
      <div id="ic1f4l" className="">
      
      <div className="" id="i2tyw5">
        
      <span className="" id="isqcjp">
        <>La pandemia, la disrupción<br />tecnológica, y la avalancha de información han<br /></>
      </span>
      
      <span className="" id="iqwv5w">
        <>aumentado la incertidumbre </>
      </span>
      
      <span className="" id="iy2k1t">
        <>en el mundo de los<br />negocios, forzando la </>
      </span>
      
      <span className="" id="i8prqg">
        <>transformación de los roles<br /></>
      </span>
      
      <span className="" id="iisbf4">
        <>dentro de las organizaciones.</>
      </span>
      
      </div>
      
      </div>
      
      <img
        className=""
        id="iqu6j1"
        src="https://assetsprojects.s3.amazonaws.com/eewk5ilyoqwd2k.jpg"
        alt="undefined"
      />
      
      </div>
      
      </div>
      
      <div id="i0eta9" className="">
      
      <div
        id="iffvy7"
        className=""
        data-aos="fade-up"
        data-aos-duration="undefined"
      >
      
      <img
        className=""
        id="itzwm6"
        src="https://assetsprojects.s3.amazonaws.com/eewk5ilyoqwd2k.jpg"
        alt="undefined"
      />
      
      <div id="ihsxj5" className="">
      
      <p className="" id="io7lhv">
        
      <span className="" id="ite2b1">
        <>Antes, el CFO se centraba solo en la gestión de<br />finanzas y el cumplimiento normativo. Ahora, debe<br />tener una visión más amplia del negocio,<br /></>
      </span>
      
      <span className="" id="igkd9u">
        <>convirtiendo datos en información clave </>
      </span>
      
      <span className="" id="ies1h6">
        <>que<br />permita aterrizarla en un entendimiento a fondo de<br />la situación de la empresa </>
      </span>
      
      <span className="" id="ijtbqa">
        <>conectada </>
      </span>
      
      <span className="" id="ia8kni">
        <>a la situación<br />de mercado y de la coyuntura económica. </>
      </span>
      
      </p>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="ihtp5k" className="">
      
      <div
        id="i0pb8w"
        className=""
        data-aos="fade-up"
        data-aos-duration="undefined"
      >
      
      <div id="isfhqx" className="">
      
      <div className="" id="imyixi">
        
    <div id="" className="page ">
    
    <div id="" className="section ">
    
    <div id="" className="layoutArea ">
    
    <div id="" className="column ">
    
      <p className="" id="iphf0g">
        
      </p>
      
    <div id="" className="page ">
    
    <div id="" className="section ">
    
    <div id="" className="layoutArea ">
    
    <div id="" className="column ">
    
      <p className="" id="">
        
      <span className="" id="ir5jo8">
        <>Esta evolución ha permitido que el CEO tenga<br /></>
      </span>
      
      </p>
      
      <p className="" id="i8ws1f">
        
      <span className="" id="ituphg">
        <>mayor control y tranquilidad sobre la<br />organización</>
      </span>
      
      <span className="" id="ioa9bl">
        <>, generando </>
      </span>
      
      <span className="" id="ip9unj">
        <>más confianza </>
      </span>
      
      <span className="" id="ic0jfz">
        <>en él y sus<br /></>
      </span>
      
      </p>
      
      <p className="" id="ih3pff">
        
      <span className="" id="i2plfw">
        <>colaboradores. Con un CFO enfocado en los<br />impulsores claves, el CEO puede tomar decisiones<br />pertinentes, informadas y dedicar </>
      </span>
      
      <span className="" id="ibu1ew">
        <>más tiempo </>
      </span>
      
      <span className="" id="iqmz7c">
        <>a<br />actividades que </>
      </span>
      
      <span className="" id="ii19ln">
        <>generan valor para la empresa. </>
      </span>
      
      </p>
      
    </div>
    
    </div>
    
    </div>
    
    </div>
    
    </div>
    
    </div>
    
    </div>
    
    </div>
    
      </div>
      
      </div>
      
      <img
        className=""
        id="ir9ytj"
        src="https://assetsprojects.s3.amazonaws.com/eewk5ilyor4en3.jpg"
        alt="undefined"
      />
      
      </div>
      
      </div>
      
      <div id="im99zj" className="">
      
      <div
        id="idkv6s"
        className=""
        data-aos="fade-up"
        data-aos-duration="undefined"
      >
      
      <img
        className=""
        id="is9wme"
        src="https://assetsprojects.s3.amazonaws.com/eewk5ilyor8zta.jpg"
        alt="undefined"
      />
      
      <div id="iul256" className="">
      
      <div className="" id="i36c7j">
        <>Asesoría en la mitigación de riesgos financieros y como cubrirse frente a los riesgos que esta mas expuesto la empresa</>
      <br className="" id="" />
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="icohi" className="">
      
      <div id="iyghfd" className="">
      
      <div id="i52pnr" className="">
      
      <div id="iys268" className="">
      
      <img
        className=""
        id="imi9j3"
        src="https://assetsprojects.s3.amazonaws.com/404m4lim0h22y66.png"
        alt="undefined"
      />
      
      </div>
      
      <div className="" id="iyo7r6">
        <>Externaliza tu CFO con TRET</>
      </div>
      
      <div className="" id="iygu8i">
        
      <a
        target=""
        className=""
        id="ionor8"
        href="mailto:gerencia@tret.com.co"
        type=""
      >
        <>gerencia@tret.com.co</>
      </a>
      
      </div>
      
      </div>
      
      <div id="id3akf" className="">
      
      <div className="" id="i160fk">
        <>Dirección</>
      </div>
      
      <div className="" id="igdgp1">
        <>Carrera 8 #85-31, Bogotá, Colombia</>
      </div>
      
      <div className="" id="io8u0g">
        
      <a
        target=""
        className=""
        id="ivbmuk"
        href="mailto:gerencia@tret.com.co"
        type=""
      >
        <>gerencia@tret.com.co</>
      </a>
      
      </div>
      
      </div>
      
      <div id="ipuzkj" className="">
      
      <div className="" id="ifh7p5">
        <>Contacto</>
      </div>
      
      <div className="" id="il1rnw">
        
      <a
        target=""
        className=""
        id="ic38zj"
        href="mailto:gerencia@tret.com.co"
        type=""
      >
        <>gerencia@tret.com.co</>
      </a>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="iou1pv" className="">
      
      <div className="" id="izq2dp">
        <>Todos lo derechos reservados</>
      </div>
      
      </div>
      
      </div>
      
      </div>
      
</div>
  );
}

const mapStateToProps = (state) => state.auth;

const mapDispatchToProps = (dispatch) => ({
 addLoftyTokenApp: (data) => dispatch(addLoftyToken(data)),
 deleteLoftytokenApp: () => dispatch(deleteLoftytoken()),
});


export default connect(mapStateToProps, mapDispatchToProps)(Planding1xyi8);
  